// extracted by mini-css-extract-plugin
module.exports = {"price":"styles_price__33UUG","small":"styles_small__2K9Hj","amount":"styles_amount__XCqr9","currency":"styles_currency__2o5FE"};